"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var menu_style_1 = require("../../components/menu/menu.style");
exports.CSS = {
    container: 'c-AssignCollections',
    isLoading: 'c-AssignCollections--IsLoading',
    content: 'c-AssignCollections__Content',
    menu: 'c-AssignCollections__Menu'
};
exports.Style = (_a = {},
    _a[exports.CSS.container] = {
        width: '600px'
    },
    _a[exports.CSS.isLoading] = {
        display: 'flex',
        'justify-content': 'center'
    },
    _a[exports.CSS.content] = {
        display: 'flex',
        'flex-direction': 'column',
        'align-items': 'start'
    },
    _a[exports.CSS.menu] = (_b = {
            width: '600px',
            position: 'absolute'
        },
        _b["& .".concat(menu_style_1.CSS.menu)] = {
            right: 'auto',
            width: '100%'
        },
        _b),
    _a);
//# sourceMappingURL=user.assign.modal.style.js.map